module.exports = __webpack_public_path__ + "img/linknau-simple.e2c21483.svg";